import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { CalendarDays, X } from "lucide-react";
import { useLocation } from "react-router-dom";

export const SavedBookingBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const saved = localStorage.getItem("savedBooking");
    if (saved) {
      setIsVisible(true);
    }
  }, [location.pathname]);

  if (!isVisible) return null;

  const isEs = location.pathname.startsWith('/es');
  const isRu = location.pathname.startsWith('/ru');
  const isZh = location.pathname.startsWith('/zh');

  const textMsg = isZh 
    ? "您有一个未完成的预约。准备好完成了吗？" 
    : isRu 
    ? "У вас есть сохраненное бронирование. Готовы завершить?" 
    : isEs 
    ? "Tienes una reserva guardada. ¿Listo para terminar?" 
    : "You have a saved booking in progress. Ready to finish?";
    
  const textBtn = isZh ? "完成预约" : isRu ? "Завершить" : isEs ? "Completar Reserva" : "Complete Booking";

  const handleDismiss = () => {
    localStorage.removeItem("savedBooking");
    setIsVisible(false);
  };

  const handleComplete = () => {
    document.dispatchEvent(new CustomEvent('open-booking'));
    localStorage.removeItem("savedBooking");
    setIsVisible(false);
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-primary text-primary-foreground px-4 py-3 shadow-md flex items-center justify-between animate-in slide-in-from-top duration-500">
      <div className="flex items-center gap-3">
        <CalendarDays className="h-5 w-5 hidden sm:block" />
        <p className="text-sm font-medium">{textMsg}</p>
      </div>
      <div className="flex items-center gap-2">
        <Button 
          variant="secondary" 
          size="sm" 
          onClick={handleComplete} 
          className="text-xs h-8 whitespace-nowrap font-bold"
        >
          {textBtn}
        </Button>
        <button 
          onClick={handleDismiss} 
          className="p-1.5 hover:bg-primary-foreground/20 rounded-full transition-colors ml-1"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
